'use client';

import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';
import type { PageContext } from '@/types/chat';

const ChatPageCtx = createContext<{
  pageContext: PageContext;
  setPageContext: (ctx: PageContext) => void;
  getRequestPageContext: () => PageContext;
}>({
  pageContext: { page: 'home' },
  setPageContext: () => {},
  getRequestPageContext: () => ({ page: 'home' }),
});

export function ChatPageProvider({ children }: { children: ReactNode }) {
  const [pageContext, setPageContext] = useState<PageContext>({ page: 'home' });

  const getRequestPageContext = useCallback((): PageContext => pageContext, [pageContext]);

  return (
    <ChatPageCtx.Provider value={{ pageContext, setPageContext, getRequestPageContext }}>
      {children}
    </ChatPageCtx.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useChatPageContext() {
  return useContext(ChatPageCtx);
}
